import {
  FETCH_LOYALTY_CONFIG_REQUEST,
  FETCH_LOYALTY_CONFIG_SUCCESS,
  FETCH_LOYALTY_CONFIG_FAILURE,
  CREATE_LOYALTY_CONFIG_REQUEST,
  CREATE_LOYALTY_CONFIG_SUCCESS,
  CREATE_LOYALTY_CONFIG_FAILURE,
  UPDATE_LOYALTY_CONFIG_REQUEST,
  UPDATE_LOYALTY_CONFIG_SUCCESS,
  UPDATE_LOYALTY_CONFIG_FAILURE,
  DELETE_LOYALTY_CONFIG_REQUEST,
  DELETE_LOYALTY_CONFIG_SUCCESS,
  DELETE_LOYALTY_CONFIG_FAILURE,
} from "../actions/types";


const initialState = {
  config: null,
  loading: false,
  error: null,
  message: "",
};


const loyaltyConfigReducer = (state = initialState, action) => {
  switch (action.type) {

    case FETCH_LOYALTY_CONFIG_REQUEST:
    case CREATE_LOYALTY_CONFIG_REQUEST:
    case UPDATE_LOYALTY_CONFIG_REQUEST:
    case DELETE_LOYALTY_CONFIG_REQUEST:
      return { ...state, loading: true, error: null, message: "" };

    case FETCH_LOYALTY_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        config: action.payload,
        message: "Config loaded successfully",
      };

    case CREATE_LOYALTY_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        config: action.payload,
        message: "Config created successfully",
      };

    case UPDATE_LOYALTY_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        config: action.payload,
        message: "Config updated successfully",
      };

    case DELETE_LOYALTY_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        config: null,
        message: "Config deleted successfully",
      };

    case FETCH_LOYALTY_CONFIG_FAILURE:
    case CREATE_LOYALTY_CONFIG_FAILURE:
    case UPDATE_LOYALTY_CONFIG_FAILURE:
    case DELETE_LOYALTY_CONFIG_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        message: "",
      };

    default:
      return state;
  }
};

export default loyaltyConfigReducer;